
let data = [
  {
    id: Math.random() * 10,
    name: "Sale_Expense_Formula",
    fields: [
      {
        id: Math.random() * 10,
        name: "Tax_Name",
        label: "Name",
      },


      {
        id: Math.random() * 10,
        name: "Tax_Rate",
        label: " Tax Rate",
        type: "InputDropForQuery",
        masterName: "TaxPercentage",
        min: 0,
        max: Infinity,
        // isRequired: true,
        ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "Tax_Type",
        label: "Tax Type",
        type: "inputdrop",
        dropdowncontent: ["CGST", "SGST", "IGST", "UGST"],
        min: 0,
        max: Infinity,
      },
    ],
  },

  // {
  //   id: Math.random() * 10,
  //   name: "Sales_details3",
  //   fields: [
  //     {
  //       name: "Sidebyside",
  //       Label: "Calculation:",
  //       Subfields: [
  //         {
  //           id: Math.random() * 10,
  //           name: "Calculation_Type",
  //           label: "Type",
  //           type: "inputdrop",
  //           dropdowncontent: ["Percentage", "Round Off", "Fixed"],

  //           min: 0,
  //           max: Infinity,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Sidebyside",
  //       Label: "Calculation_Based_On:",
  //       Subfields: [
  //         {
  //           id: Math.random() * 10,
  //           name: "Calculation_Based_Type",
  //           label: "Type",
  //           type: "inputdrop",
  //           dropdowncontent: ["Fixed", "Round Off"],
  //           min: 0,
  //           max: Infinity,
  //         },
  //       ],
  //     },

  //     {
  //       name: "Sidebyside",
  //       Label: "Apply In Case:",
  //       Subfields: [
  //         {
  //           id: Math.random() * 10,
  //           name: "Apply_Type",
  //           label: "Type",
  //           type: "inputdrop",
  //           dropdowncontent: ["CGST", "SGST", "IGST", "UGST"],
  //           min: 0,
  //           max: Infinity,
  //         },
  //         {
  //           id: Math.random() * 10,
  //           name: "Tax_Percentage",
  //           label: " Tax Percentage",
  //           type: "InputDropForQuery",
  //           masterName: "TaxPercentage",
  //           min: 0,
  //           max: Infinity,
  //           isRequired: false,
  //           ValidationType: "VALID_STRING",
  //         },
  //       ],
  //     },

  //     {
  //       id: Math.random() * 10,
  //       name: "Expense_Account",
  //       label: "Expense Account ",
  //       masterName: "General_Account",
  //       type: "InputDropForQuery",
  //       variable: {
  //         accountType: ["General Account"],
  //       }
  //       , min: 0,
  //       isRequired: true,
  //       max: Infinity,
  //     },
  //   ],
  // },

  // {
  //   id: Math.random() * 10,
  //   name: "Sales_details4",
  //   fields: [
  //     {
  //       id: Math.random() * 10,
  //       name: "Expense_Account",
  //       label: "Expense Account",
  //       type: "inputdrop",
  //       dropdowncontent: ["GST", "IGST", "FREE", "Non GST"],
  //       min: 0,
  //       max: Infinity,
  //     },
  //   ],
  // },
];

export { data };
